const GenerateReport = () => import("./views/GenerateReport.vue");
const AllReport = () => import("./views/AllReport.vue");
const AppraisalReport = () => import("./views/AppraisalReport.vue");
const FeebackReport = () => import("./views/FeebackReport.vue");

export default [
  {
    path: "generate",
    name: "generate-performance-report",
    component: GenerateReport,
  },
  {
    path: "all",
    name: "performance-view-report",
    component: AllReport,
  },
  {
    path: "appraisal-report",
    name: "appraisal-report",
    component: AppraisalReport,
  },
  {
    path: "feedback-report",
    name: "feedback-report",
    component: FeebackReport,
  },
];
